// Correios (Com ou sem contrato)
(function () {
  'use strict';
  function handleCorreiosContrato() {
    comContrato();
  }
  handleCorreiosContrato();
  function comContrato() {
    $('.campos-comcontrato-wrp').show();
  }
  function semContrato() {
    $('.campos-comcontrato-wrp').hide();
    $('.campos-comcontrato-wrp input').prop('required', false);
  }
})();

// Exibe o modal para configuração do frete
(function () {
  'use strict';

  // Variáveis
  const $modal = $('#modal-gateway-frete');
  const $modalTitle = $modal.find('.modal-title');
  const $form = $('#form-gateway-frete');
  const $inputForma = $modal.find('input[name="forma"]');

  // Evento de clique no botão para configurar
  $('[data-conf-frete]').on('click', function () {
    const cfg = $(this).data('conf-frete');
    const url = $(this).data('conf-url');
    showGatewayCfgModal(cfg, url);
  });

  // Exibe o modal com base na configuração
  function showGatewayCfgModal(cfg, url) {
    //console.log(cfg);

    const $wrpCampos = $('[data-campos-frete="' + cfg.forma + '"]');
    const $wrpCamposInputs = $wrpCampos.find('input, select, textarea');

    $('[data-campos-frete]').hide();
    $('[data-campos-frete]').find('input, select, textarea').prop('required', false);
    $wrpCampos.show();

    // Demais configurações
    $modalTitle.text('Configurar ' + cfg.titulo);
    $inputForma.val(cfg.forma);

    getGatewayInfos(url);
    //$modal.modal('show');
  }

  // Obtém os dados de um registro
  function getGatewayInfos(url) {
    showLoader();
    $.getJSON(`${url}`, function (resp) {
      console.log(resp);
      if (resp.status == 'success') {
        // Popula o formulário
        resetFormInputs($modal);
        populaForm(resp.registro);
      } else {
        hideLoader();
        Toast.fire({
          type: 'error',
          title: resp.mensagem,
        });
      }
    }).fail(function (resp) {
      console.log(resp);
      hideLoader();
      Toast.fire({
        type: 'error',
        title: 'Não foi possível carregar os dados do registro.',
      });
    });
  }

  // Popula o formulário com os dados do registro a ser editado
  function populaForm(registro) {
    const ignoredFields = ['token', 'retorno'];
    for (let row in registro) {
      if (ignoredFields.indexOf(row) !== -1) {
        continue;
      }
      const $input = $modal.find(`[name="${row}"]`);
      if ($input.length > 0) {
        // Checkbox e radios
        if ($input.attr('type') == 'checkbox' || $input.attr('type') == 'radio') {
          $input.prop('checked', false);
          $modal.find(`[name="${row}"][value="${registro[row]}"]`).prop('checked', true);
          if ($input.attr('type') == 'radio') {
            $modal.find(`[name="${row}"][value="${registro[row]}"]`).click();
          }
        }
        // Campos padrões
        else {
          $input.val(registro[row]);
        }
        if (row == 'me_jadlog_unidade') {
          $input.data('value', registro[row]);
        }
        $input.trigger('change');
      }
    }
    if ($('#cep_origem').val() != '') {
      $('#campos-endereco-forma').show();
    }
    $form.parsley().reset();
    hideLoader();
    $modal.modal('show');
  }
})();

// Unidades Jadlog
(function () {
  'use strict';

  // Campos unidades
  const $inputs = $('.select2-jadlog');
  const $unidadesWrp = $('.unidade-jadlog-wrp');

  // Carrega as unidades ao abrir o modal ou alterar a cidade ou estado
  //$('#modal-gateway-frete').on('show.bs.modal', getUnidadesJadlog);
  $('#modal-gateway-frete #estado, #modal-gateway-frete #cidade').on('change', getUnidadesJadlog);
  //Kangu estabelecimentos
  $('#modal-gateway-kangu #cep_origem, #token_kangu').on('change', getKanguEstabelecimentos);
  if ($('#modal-gateway-kangu #cep_origem').val() != '' && $('#token_kangu').val() != '') {
    getKanguEstabelecimentos();
  }

  // Verifica se há algum opção da Jadlog marcada
  $('#me_jadlog_package, #me_jadlog_com').on('change', handleModalidadesJadlog);
  function handleModalidadesJadlog() {
    if ($('#me_jadlog_package').is(':checked') || $('#me_jadlog_com').is(':checked')) {
      $unidadesWrp.show();
    } else {
      $unidadesWrp.hide();
    }
  }

  // Aplica o plugin nos campos
  function initSelect2Unidades() {
    $inputs.each(function () {
      const $input = $(this);
      const maximumSelectionLength = $input.data('max') ? parseInt($input.data('max')) : 0;
      const placeholder = $input.data('placeholder') ? $input.data('placeholder') : false;
      const search = $input.data('search') ? true : false;
      const searchPlaceholder = $input.data('src-placeholder') ? $input.data('src-placeholder') : 'Pesquisar...';
      const url = $input.data('url');
      const paramsAdd = $input.data('params');
      const options = {
        width: '100%',
        language: 'pt-BR',
        maximumSelectionLength: maximumSelectionLength,
        searchInputPlaceholder: searchPlaceholder,
      };
      if (!search) {
        options.minimumResultsForSearch = -1;
      }
      if (placeholder) {
        options.placeholder = placeholder;
      }
      $input.select2(options).on('change.select2-prods', function (ev) {
        $(ev.currentTarget).parsley().validate();
      });
    });
  }

  // Retorna as unidades
  function getKanguEstabelecimentos() {
    if ($('#token_kangu').length) {
      let cep = $('#modal-gateway-kangu #cep_origem').val();
      let token_kangu = $('#modal-gateway-kangu #token_kangu').val();
      let url_consulta =
        urlBase +
        'core/acoes/app/opcoes/fretes_aux.php?cep=' +
        cep +
        '&action=get_estabelecimentos&gateway=kangu&token_kangu=' +
        token_kangu;
      $.getJSON(url_consulta, function (unidades) {
        console.log(unidades);
        if (Array.isArray(unidades) && unidades.length > 0) {
          $inputs.each(function () {
            const $input = $(this);
            const inputValue = $input.data('value');
            $input.html('');
            $input.append(`<option></option>`);
            unidades.forEach((un) => {
              const selected = inputValue == un.cnpjCpf ? 'selected' : '';
              $input.append(
                `<option value="${un.cnpjCpf}" ${selected}>${un.nome} - ${un.endereco.logradouro}, ${un.endereco.numero} - ${un.endereco.bairro} ${un.endereco.cidade}/${un.endereco.uf}</option>`,
              );
            });
          });
        } else {
          console.log('Nenhum estabelecimento encontrado.');
        }
        initSelect2Unidades();
      }).fail(function () {
        console.log('Não foi possível obter as unidades.');
      });
    }
  }

  // Retorna as unidades
  function getUnidadesJadlog() {
    // let url = 'https://www.melhorenvio.com.br/api/v2/me/shipment/agencies?company=2&country=BR';
    // if ($('#estado').val()) {
    //   url += '&state=' + $('#estado').val();
    // }
    // if ($('#cidade').val()) {
    //   url += '&city=' + $('#cidade').val();
    // }
    let state = $('#estado').val();
    let city = $('#cidade').val();
    let url_consulta =
      urlBase +
      'core/acoes/app/opcoes/fretes_aux.php?city=' +
      city +
      '&state=' +
      state +
      '&action=get_unidades&gateway=melhorenvio';
    console.log(url_consulta);
    $.getJSON(url_consulta, function (unidades) {
      console.log(unidades);
      if (Array.isArray(unidades) && unidades.length > 0) {
        $inputs.each(function () {
          const $input = $(this);
          const inputValue = $input.data('value');
          $input.html('');
          $input.append(`<option></option>`);
          unidades.forEach((un) => {
            const selected = inputValue == un.id ? 'selected' : '';
            $input.append(`<option value="${un.id}" ${selected}>${un.name}</option>`);
          });
        });
      } else {
        console.log('Nenhuma unidade encontrada.');
      }
      initSelect2Unidades();
    }).fail(function () {
      console.log('Não foi possível obter as unidades.');
    });
  }
})();
